export enum Permission {
  VIEW = 1,
  CONTROL = 2,
  MISSION_EXECUTION = 3,
  ARM_CONTROL = 4,
}

export type RobotUser = {
  userName: string;
  userEmail?: string;
  canViewRobot: boolean;
  canControlRobot: boolean;
  canExecuteMissions: boolean;
  canControlArm: boolean;
};

export type SortingState = { id: string; desc: boolean };
